import { render, staticRenderFns } from "./writeoffSearchAreaHeader.vue?vue&type=template&id=5b85b4aa&v-slot%3AsearchAreaHeader=true&"
import script from "./writeoffSearchAreaHeader.vue?vue&type=script&lang=js&"
export * from "./writeoffSearchAreaHeader.vue?vue&type=script&lang=js&"
import style0 from "./writeoffSearchAreaHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b85b4aa')) {
      api.createRecord('5b85b4aa', component.options)
    } else {
      api.reload('5b85b4aa', component.options)
    }
    module.hot.accept("./writeoffSearchAreaHeader.vue?vue&type=template&id=5b85b4aa&v-slot%3AsearchAreaHeader=true&", function () {
      api.rerender('5b85b4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/Writeoff/writeoffSearchAreaHeader.vue"
export default component.exports